<template>
  <div>
    <!-- 处理逻辑待定，暂时不显示 -->
    <!-- <span v-if="typeName" class="que-type">{{ typeName }}</span> -->
    <div class="tksdk_topic_content" v-html="contentHtml" />
    <div v-if="answerParsing" class="options-wrap">
      <div class="options tksdk_options" v-for="item in answerParsing" :key="item.option">
        <span class="tag tksdk_options_tag">{{ item.option }}</span>
        <div class="options-content tksdk_options_content" v-html="item.contentHtml" />
      </div>
    </div>
    <div class="answer" v-if="answers">
      <p>正确答案：</p>
      <div v-for="(answer, index) in answers" :key="index" class="tksdk_options_content" v-html="answer.option" />
    </div>
  </div>
</template>
<script>
// 题库
import { onMounted } from '@vue/composition-api'
import { tkSdkNew } from '@/utils/tools.js'
export default {
  props: {
    // 题目类型 1=选择题，0=填空题
    topicType: Number,
    // 题干
    contentHtml: String,
    // 选项
    answerParsing: Array,
    // 正确答案
    answers: Array
  },
  setup() {
    // const typeMap = {
    //   1: "选择题",
    //   0: "填空题"
    // }
    // const typeName = computed(() => {
    //   const { topicType } = props
    //   return typeMap[topicType]
    // })
    onMounted(() => {
      tkSdkNew.runMathjax()
    })
  }
}
</script>
<style lang="less" scoped>
.tksdk_topic_content {
  font-size: 16px;
}
.que-type {
  height: 24px;
  background: #ffffff;
  /* 灰色/N60 */
  border: 2px solid #dfe2e6;
  border-radius: 6px;
  padding: 0 6px;
  display: inline-flex;
  align-items: center;
  margin-bottom: 16px;
}
.options-wrap {
  margin-top: 16px;
}
.options {
  background: #ffffff;
  border-radius: 6px;
  display: flex;
  padding: 10px 20px 10px 0;
  align-items: center;
  margin-bottom: 12px;
  font-size: 14px;
  .tag {
    font-size: 16px;
    width: 37px;
    display: flex;
    justify-content: center;
  }
  .options-content {
    padding-left: 20px;
    position: relative;
    &:before {
      position: absolute;
      content: " ";
      opacity: 0.2;
      /* 标题 颜色 一级 */
      background: #3e416d;
      width: 1px;
      height: 100%;
      left: 0;
      top: 0;
    }
  }
}
.answer {
  margin-top: 24px;
  display: flex;
  align-items: center;
  font-size: 14px;
}
</style>
